import React, { Fragment, useState } from 'react';
import withCopyEdit from '../data-container';
import { DataEntryGroup } from '../data-components/data-entry-group';
import InfoBox from '../../components/info-box';
import { dataFields } from '../../config/data-fields-config';
import DataEntry from '../data-components/data-entry';
import AttachmentDataEntry from '../data-components/attachment-data-entry';
const InvestmentEngagementView = (props) => {
    const queryParameters = new URLSearchParams(window.location.search);
    const subcat = queryParameters.get("sc");
    const [engagementIntent, setEngagementIntent] = useState(null);
    const [submissionFiles, setSubmissionFiles] = useState({});
    const [submitState, setSubmitState] = useState('idle');
    const [submitMessage, setSubmitMessage] = useState('');
    const hasExistingEngagement = !!(props.building.engagement_full_name ||
        props.building.engagement_ownership_evidence ||
        (props.building.engagement_attachments && props.building.engagement_attachments.length));
    const showEngagementFields = engagementIntent === true || hasExistingEngagement;
    const queuedFileCount = Object.values(submissionFiles).reduce((total, files) => total + files.length, 0);
    const retainUploadedFiles = (slug, files) => {
        setSubmissionFiles(current => {
            var _a;
            const merged = [...((_a = current[slug]) !== null && _a !== void 0 ? _a : []), ...files];
            const unique = merged.filter((file, index, all) => all.findIndex(candidate => candidate.name === file.name &&
                candidate.size === file.size &&
                candidate.lastModified === file.lastModified) === index);
            return Object.assign(Object.assign({}, current), { [slug]: unique });
        });
        setSubmitState('idle');
        setSubmitMessage('');
    };
    const submitEngagement = async () => {
        var _a, _b, _c;
        if (queuedFileCount === 0 || submitState === 'sending')
            return;
        setSubmitState('sending');
        setSubmitMessage('');
        const formData = new FormData();
        formData.append('fullName', (_a = props.building.engagement_full_name) !== null && _a !== void 0 ? _a : '');
        for (const file of (_b = submissionFiles.engagement_ownership_evidence) !== null && _b !== void 0 ? _b : []) {
            formData.append('ownershipEvidence', file);
        }
        for (const file of (_c = submissionFiles.engagement_attachments) !== null && _c !== void 0 ? _c : []) {
            formData.append('attachments', file);
        }
        try {
            if (props.edited)
                props.onSaveEdits();
            const response = await fetch(`/api/buildings/${props.building.building_id}/engagement-submit`, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });
            const result = await response.json();
            if (!response.ok || result.error) {
                throw new Error(result.error || 'Submission could not be sent');
            }
            setSubmissionFiles({});
            setSubmitState('sent');
            setSubmitMessage('Submitted successfully.');
        }
        catch (error) {
            setSubmitState('error');
            setSubmitMessage(error instanceof Error ? error.message : 'Submission could not be sent');
        }
    };
    return (React.createElement(Fragment, null,
        React.createElement(DataEntryGroup, { name: "Investment", collapsed: subcat == null || subcat != "1" },
            React.createElement(InfoBox, { type: "warning" }, "This section is under development.")),
        React.createElement(DataEntryGroup, { name: "Engagement", collapsed: subcat == null || subcat != "2" },
            React.createElement("p", { className: "data-intro" }, "Do you have any information you would like to Verify about this building?"),
            React.createElement("div", { className: "btn-group btn-group-toggle", style: { marginBottom: '0.75rem' } },
                React.createElement("button", { type: "button", className: `btn ${engagementIntent === true || (engagementIntent === null && hasExistingEngagement) ? 'btn-primary' : 'btn-outline-dark'}`, disabled: props.mode === 'view', onClick: () => setEngagementIntent(true) }, "Yes"),
                React.createElement("button", { type: "button", className: `btn ${engagementIntent === false ? 'btn-primary' : 'btn-outline-dark'}`, disabled: props.mode === 'view', onClick: () => setEngagementIntent(false) }, "No")),
            showEngagementFields ? (React.createElement(React.Fragment, null,
                React.createElement(DataEntry, { title: dataFields.engagement_full_name.title, slug: "engagement_full_name", value: props.building.engagement_full_name, tooltip: dataFields.engagement_full_name.tooltip, mode: props.mode, copy: props.copy, onChange: props.onChange }),
                React.createElement(AttachmentDataEntry, { title: "Property Ownership / Supporting Evidence (CPR)", slug: "engagement_ownership_evidence", value: props.building.engagement_ownership_evidence
                        ? [String(props.building.engagement_ownership_evidence)]
                        : null, tooltip: dataFields.engagement_ownership_evidence.tooltip, mode: props.mode, copy: props.copy, onChange: (slug, value) => {
                        const names = Array.isArray(value) ? value : null;
                        props.onChange(slug, names && names.length ? names.join(', ') : null);
                    }, onUploadSave: (slug, value) => {
                        const names = Array.isArray(value) ? value : null;
                        props.onSaveEdits({
                            [slug]: names && names.length ? names.join(', ') : null,
                        });
                    }, onFilesUploaded: retainUploadedFiles, accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp,.mp3,.mp4,.mov,.wav" }),
                React.createElement(AttachmentDataEntry, { title: dataFields.engagement_attachments.title, slug: "engagement_attachments", value: props.building.engagement_attachments, tooltip: dataFields.engagement_attachments.tooltip, mode: props.mode, copy: props.copy, onChange: props.onChange, onUploadSave: (slug, value) => {
                        props.onSaveEdits({ [slug]: value });
                    }, onFilesUploaded: retainUploadedFiles, accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp,.mp3,.mp4,.mov,.wav" }),
                props.mode !== 'view' && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "buttons-container with-space" },
                        React.createElement("button", { type: "button", className: "btn btn-primary", disabled: queuedFileCount === 0 || submitState === 'sending', onClick: submitEngagement }, submitState === 'sending' ? 'Submitting…' : 'Submit')),
                    submitMessage && (React.createElement("p", { className: submitState === 'sent' ? 'text-success' : 'text-danger', role: "status" }, submitMessage)))))) : null)));
};
const InvestmentEngagementContainer = withCopyEdit(InvestmentEngagementView);
export default InvestmentEngagementContainer;
